import axios from 'axios'
import { getEnvironmentInfo } from './envInfo'

const eventTrackerAxios = axios.create()

const url = import.meta.env.VITE_EVENT_TRACKER_URL
const username = import.meta.env.VITE_EVENT_TRACKER_USERNAME
const password = import.meta.env.VITE_EVENT_TRACKER_PASSWORD
const eventName = 'belajarid_web_event_tracker_v1'

export async function trackSatuEvent(data: any) {
  if (!url || !username || !password)
    throw new Error('SatuEvent env variables are not set')

  // Handle auth
  const usernamePasswordString = `${username || ''}:${password || ''}`
  const auth = typeof window !== 'undefined'
    ? window.btoa(usernamePasswordString)
    : Buffer.from(usernamePasswordString).toString('base64')

  const envInfo = getEnvironmentInfo()
  const combinedData = {
    ...envInfo,
    ...data,
  }

  const body = {
    event_name: eventName,
    data: JSON.stringify(combinedData),
  }

  await eventTrackerAxios.post(url, body, {
    headers: {
      'accept': '*/*',
      'accept-language': 'en-US,en;q=0.6',
      'authorization': `Basic ${auth}`,
      'cache-control': 'no-cache',
      'content-type': 'application/json',
    },
  })
}
